import { StatusPair } from '../models/status-pair';

export class GenderData {
  private genderList: StatusPair[] = [new StatusPair('Male', 'M'), new StatusPair('Female', 'F')];

  public getGenderList(): Array<StatusPair> {
    return this.genderList;
  }


}
